import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { CheckNameExistsRequest, PositionClient } from 'src/app/shared/api-connector/sso-connector';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AutocompleteCacheService } from 'src/app/shared/services/autocomplete-cache.service';

@Component({
  selector: 'app-add-position-dialog',
  templateUrl: './add-position-dialog.component.html',
  styleUrls: ['./add-position-dialog.component.scss']
})
export class AddPositionDialogComponent implements OnInit {
  nameCtrl = new FormControl('', {
    validators: [Validators.required],
    updateOn: 'change',
    asyncValidators: [this.validatePositionNameNotTaken.bind(this)]
  });
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<AddPositionDialogComponent>,
    private alertService: AlertService,
    private positionClient: PositionClient,
    private autocompleteCache: AutocompleteCacheService
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

  validatePositionNameNotTaken(control: FormControl): any {
    if (control.value) {
      return this.positionClient.checkPositionNameExists(new CheckNameExistsRequest({
        name: this.nameCtrl.value
      })).pipe(
        map(res => {
          return res ? { nameTaken: true } : null;
        }));
    } else {
      return of(null);
    }
  }

  onSubmit() {
    if (this.nameCtrl.valid) {
      this.spinner.show();
      this.positionClient.create(this.nameCtrl.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe(x => {
          this.autocompleteCache.clearType('position_');
          this.alertService.success('Thêm mới vị trí thành công', 'Thêm vị trí');
          this.dialogRef.close(this.nameCtrl.value);
        });
    }
  }
}
